/* eslint-disable no-restricted-syntax */

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/* global _OL_ORIGIN */
import SocketCluster from 'socketcluster-client/index';
import async from 'async';
import $ from 'jquery';
import { EventEmitter } from 'events';
import { captureException } from '@sentry/browser';
import { data as UserMessagingData } from '../chat/src/chatDataLoader';
import { Store } from '../../ReduxStorage/Store';
import { currentUserIdSelector } from '../../ReduxStorage/Auth/selectors';
import {
  REALTIME_HOSTNAME,
  REALTIME_PORT,
  REALTIME_SECURE,
} from '../../ReduxStorage/location/constants';

// global _OL_ORIGIN

// Idle time before socketcluster disconnects
const IDLE_TIMEOUT = 60 * 30;

// How many seconds of valid authentication left before we log in again
// (Make sure the server will renew an auth token this old)
const RENEW_EARLY_BY = 60;

// A queue will be used so that no more than this number of subscribe/
// unsubscribe/emit/publish tasks will run at once (to prevent timeouts)
const MAX_CONCURRENT_SOCKETCLUSTER_REQUESTS =
  _BUILD_TYPE === 'staging' ? 5 : 30;

const taskWorker = (task, callback) => {
  return task(callback);
};
const taskQueue = async.queue(
  taskWorker,
  MAX_CONCURRENT_SOCKETCLUSTER_REQUESTS
);

// JSON stringify an array of strings in a deterministic fashion
const stringifyPath = (path) => {
  const strings = [];
  for (const string of path) {
    if (typeof string !== 'string') {
      throw Error('Invalid path');
    }
    strings.push(JSON.stringify(string));
  }
  return `[${strings.join(',')}]`;
};

// Get a temporary OLAuth token from python to authenticate to socketcluster
const getTempAuthToken = (callback) => {
  $.ajax({
    url: `${_OL_ORIGIN}/json/auth/`,
    method: 'POST',
    xhrFields: {
      withCredentials: true,
    },
    data: {
      tokenType: 'temporary',
    },
    success: (data) => {
      const json = JSON.parse(data);
      if (json.success) {
        return callback(null, json.auth_token);
      } else {
        return callback(data);
      }
    },
    error: (xhr, textStatus) => {
      return callback(textStatus);
    },
  });
};

const documentHasFocus = () => {
  if (typeof document.hasFocus === 'undefined') {
    // Opera...
    return document.visibilityState === 'visible';
  } else {
    return document.hasFocus();
  }
};

class Presence {
  // EVENTS
  // - onlinelist, handler(onlineList)
  // - availability, handler(true/false)

  constructor(prefix, presencePath, clientType) {
    this.presencePath = presencePath;
    this.clientType = clientType;
    this.availability = false;
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    this.socket = realTime.socket;
    this.emitter = new EventEmitter();
    this.initialListNeeded = true;
    this.profileName = UserMessagingData.userMessaging
      ? UserMessagingData.userMessaging.myProfileName
      : null;

    this.updatesChannel = this.socket.channel(
      stringifyPath(['onlineList', prefix, presencePath])
    );
    const initialEndpointName = stringifyPath(['getInitialOnlineList']);
    this.availableChannel = this.socket.channel(
      stringifyPath([
        'available',
        prefix,
        presencePath,
        this.profileName,
        this.clientType,
      ])
    );

    this.updatesChannel.watch((data) => {
      this.initialListNeeded = false;
      this.emitter.emit('onlinelist', data);
    });

    this.updatesChannel.on('subscribe', () => {
      if (this.initialListNeeded) {
        this.socket.emit(
          initialEndpointName,
          stringifyPath([prefix, presencePath]),
          (err, data) => {
            if (err) {
              // eslint-disable-next-line no-console
              console.log(err);
            } else if (this.initialListNeeded) {
              this.emitter.emit('onlinelist', data);
            }
          }
        );
      }
    });

    this.updatesChannel.on('unsubscribe', () => {
      this.initialListNeeded = true;
    });

    this.availableChannel.on('subscribe', () => {
      return this.emitter.emit('availability', true);
    });

    this.availableChannel.on('unsubscribe', () => {
      return this.emitter.emit('availability', false);
    });
  }

  on = (event, handler) => {
    return this.emitter.on(event, handler);
  };

  off = (event, handler) => {
    return this.emitter.removeListener(event, handler);
  };

  setAvailability = (newAvailability) => {
    if (newAvailability && !this.availability) {
      this.availability = true;
      taskQueue.push((callback) => {
        this.availableChannel.subscribe();
        this.availableChannel.once('subscribe', () => {
          callback(null);
        });
      });

      taskQueue.push((callback) => {
        this.updatesChannel.subscribe();
        this.updatesChannel.once('subscribe', () => {
          callback(null);
        });
      });
    } else if (!newAvailability && this.availability) {
      this.availability = false;
      taskQueue.push((callback) => {
        this.availableChannel.unsubscribe();
        this.availableChannel.once('unsubscribe', () => {
          callback(null);
        });
      });

      taskQueue.push((callback) => {
        this.updatesChannel.unsubscribe();
        this.updatesChannel.once('unsubscribe', () => {
          callback(null);
        });
      });
    }
  };
}

// A client API for other javascript to use to communicate with the
// real time system (so that we can later abstract over the this.sockets)
class RealTimeClient {
  rt = null;

  socket = null;

  constructor(realTime, prefix) {
    this.prefix = prefix;
    if (!this.prefix.match(/.+/)) {
      throw Error('Realtime client prefix must be a non-empty string');
    }
    this.rt = realTime;
    this.socket = this.rt.socket;
  }

  addPrefix = (path) => {
    if (!(path instanceof Array)) {
      // eslint-disable-next-line no-param-reassign
      path = JSON.parse(path);
    }
    return stringifyPath([this.prefix].concat(path));
  };

  hasPrefix = (path) => {
    if (!(path instanceof Array)) {
      // eslint-disable-next-line no-param-reassign
      path = JSON.parse(path);
    }
    return path[0] === this.prefix;
  };

  removePrefix = (path) => {
    if (!(path instanceof Array)) {
      // eslint-disable-next-line no-param-reassign
      path = JSON.parse(path);
    }
    return stringifyPath(path.splice(1));
  };

  subscribe = (channelName) => {
    const channel = this.socket.channel(this.addPrefix(channelName));
    return taskQueue.push((callback) => {
      channel.subscribe();
      return channel.on('subscribe', () => {
        return callback(null);
      });
    });
  };

  channel = (channelName) => {
    return this.socket.channel(this.addPrefix(channelName));
  };

  unsubscribe = (channelName) => {
    const channel = this.socket.channel(this.addPrefix(channelName));
    return taskQueue.push((callback) => {
      channel.unsubscribe();
      return channel.on('unsubscribe', () => {
        return callback(null);
      });
    });
  };

  watch = (channelName, handler) => {
    return this.socket.watch(this.addPrefix(channelName), handler);
  };

  unwatch = (channelName, handler) => {
    return this.socket.unwatch(this.addPrefix(channelName), handler);
  };

  publish = (channelName, data, callback) => {
    return taskQueue.push((taskCallback) => {
      return this.socket.publish(this.addPrefix(channelName), data, (err) => {
        taskCallback(null);
        return callback(err);
      });
    });
  };

  emit = (event, data, callback) => {
    return taskQueue.push((taskCallback) => {
      return this.socket.emit(this.addPrefix(event), data, (err) => {
        taskCallback(null);
        return callback(err);
      });
    });
  };

  getPresence = (presencePath, clientType) => {
    return new Presence(this.prefix, presencePath, clientType);
  };

  on = (event, handler) => {
    // Channel events
    if (['subscribe', 'subscribeFail', 'unsubscribe'].indexOf(event) !== -1) {
      this.socket.on(event, (channelName) => {
        if (this.hasPrefix(channelName)) {
          handler(this.removePrefix(channelName));
        }
      });
    } else if (event === 'kickOut') {
      this.socket.on(event, (message, channelName) => {
        if (this.hasPrefix(channelName)) {
          handler(message, this.removePrefix(channelName));
        }
      });

      // Socket events
    } else if (['error', 'connect', 'disconnect'].indexOf(event) !== -1) {
      this.socket.on(event, handler);

      // Status events
    } else if (['ready', 'idle', 'return'].indexOf(event) !== -1) {
      this.rt.emitter.on(event, handler);

      // Arbitrary this.socket events
    } else {
      this.socket.on(this.addPrefix(event), handler);
    }
  };

  off = (event, handler) => {
    // Channel events
    if (['subscribe', 'subscribeFail', 'unsubscribe'].indexOf(event) !== -1) {
      throw Error('Not implemented');
    } else if (event === 'kickOut') {
      throw Error('Not implemented');

      // Socket events
    } else if (['error', 'connect', 'disconnect'].indexOf(event) !== -1) {
      return this.socket.off(event, handler);

      // Status events
    } else if (['ready', 'idle', 'return'].indexOf(event) !== -1) {
      return this.rt.emitter.removeListener(event, handler);

      // Arbitrary this.socket events
    } else {
      return this.socket.off(this.addPrefix(event), handler);
    }
  };

  whenReady = (handler) => {
    return this.rt.whenReady(handler);
  };
}

class RealTime {
  constructor() {
    this.emitter = new EventEmitter();
    this.isReady = false;

    const state = Store.getState();
    this.userId = currentUserIdSelector(state) || null;
    this.profileName = UserMessagingData.userMessaging
      ? UserMessagingData.userMessaging.myProfileName
      : null;

    this.socket = SocketCluster.create({
      hostname: REALTIME_HOSTNAME,
      port: REALTIME_PORT,
      secure: REALTIME_SECURE,
      autoSubscribeOnConnect: false,
      ackTimeout: 20000,
    });

    // We never disconnect deliberately
    this.socket.on('close', () => {
      // TODO: This happens ALL THE TIME FOR NO REASON
    });

    this.socket.on('error', (err) => {
      // This often is the same error that lead to the close event
      if (_BUILD_TYPE !== 'live' || Math.random() < 1 / 100) {
        // Without this, our sentry quota would be caput
        captureException(err);
      }

      // eslint-disable-next-line no-console
      console.error(err);
    });

    this.socket.on('connect', (status, processSubscriptions) => {
      // Todo not log in if theres plenty of time left?
      return this.login((err) => {
        if (!err) {
          if (!this.isReady) {
            // eslint-disable-next-line no-console
            console.log('Socket reconnected');
          }
          processSubscriptions();
        }
      });
    });

    if (!documentHasFocus()) {
      this.onLeave();
    }

    window.addEventListener('blur', this.onLeave);
    window.addEventListener('focus', this.onReturn);
  }

  login = (callback) => {
    clearTimeout(this.loginTimeout);

    if (this.socket.state === this.socket.OPEN) {
      this.noIdle();
      getTempAuthToken((err, authToken) => {
        if (err) {
          // eslint-disable-next-line no-console
          console.log('Failed to get temporary token:', err);
          return;
        }
        const credentials = {
          user_id: this.userId,
          profileName: this.profileName,
          auth_token: authToken,
        };

        this.noIdle();
        this.socket.emit('clearoldsessions', { user_id: this.userId });
        // eslint-disable-next-line no-shadow
        this.socket.emit('login', credentials, (err, timeToExpiry) => {
          if (callback) {
            callback(err);
          }
          if (err) {
            // eslint-disable-next-line no-console
            console.log('RealTime service authentication failed:', err);
          } else {
            this.loginTimeout = setTimeout(() => {
              this.login();
            }, (timeToExpiry - RENEW_EARLY_BY) * 1000);
            this.init();
          }
        });
      });
    }
  };

  init = () => {
    if (!this.isReady) {
      this.isReady = true;
      this.emitter.emit('ready');
    }
  };

  whenReady = (handler) => {
    if (this.isReady) {
      handler();
    } else {
      this.emitter.on('ready', handler);
    }
  };

  onLeave = () => {
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
    }
    this.idleTimeout = setTimeout(() => {
      this.socket.disconnect();
      this.isIdle = true;
      this.idleTimeout = null;
      this.emitter.emit('idle');
    }, IDLE_TIMEOUT * 1000);
  };

  onReturn = () => {
    if (this.idleTimeout) {
      // Hasn't gone idle yet
      clearTimeout(this.idleTimeout);
    } else {
      this.socket.connect();
      this.isIdle = false;
      this.emitter.emit('return');
    }
  };

  noIdle = () => {
    if (this.idleTimeout) {
      this.onLeave();
    }
  };

  setOnline = () => {
    const onlineChannel = this.socket.channel(
      stringifyPath(['online', this.profileName, 'desktop'])
    );

    return taskQueue.push((taskCallback) => {
      onlineChannel.subscribe();
      return onlineChannel.once('subscribe', () => {
        taskCallback(null);
      });
    });
  };
}

export const realTime = new RealTime();

export const getClient = (prefix) => new RealTimeClient(realTime, prefix);
